// Imports
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/home/Index.vue'),
      children: [
        {
          path: '',
          name: 'Accueil',
          component: () => import('@/views/home/Index.vue'),
        },
        {
          path: 'about',
          name: 'À propos',
          component: () => import('@/views/about/Index.vue'),
          meta: { src: require('@/assets/finance/hero_about.jpg') },
        },
        {
          path: 'contact',
          name: 'Contact',
          component: () => import('@/views/contact-us/Index.vue'),
          meta: { src: require('@/assets/contact.jpg') },
        },
        {
          path: 'services',
          name: 'Services',
          component: () => import('@/views/services/Index.vue'),
          meta: { src: require('@/assets/finance/hero_services.jpg') },
        },
        {
          path: 'aide-memoire',
          name: 'Aide-mémoire',
          component: () => import('@/views/aide-memoire/Index.vue'),
          meta: { src: require('@/assets/finance/hero_aide_memoire.jpg') },
        },
        {
          path: 'faq',
          name: 'Questions fréquentes',
          component: () => import('@/views/faq/Index.vue'),
          meta: { src: require('@/assets/finance/hero_faq3.jpg') },
        },
        {
          path: '*',
          name: 'FourOhFour',
          component: () => import('@/views/404/Index.vue'),
        },
      ],
    },

  ],
})

export default router
